<template>
    <button v-bind:type="type" v-on:click="doClick">
        <slot></slot>
    </button>
</template>

<script>
    export default {
        name: 'button',
        props: {
            type: String
        },
        methods: {
            doClick () {
                this.$emit('click');
            }
        }
    }
</script>

<style scoped lang="scss">
    button {
        background-color: cornflowerblue;
        color: white;
        border: none;
        line-height: 2em;
        border-radius: 0.2rem;
        padding: 0 1em;
        font-size: 1rem;
    }
</style>



// WEBPACK FOOTER //
// Button.vue?7714c674